module.exports = __webpack_public_path__ + "static/media/log-out-icon.1441a489.svg";